import { path } from "ramda";
import { createSelector } from "reselect";

import { VERTICAL_INFORMATION } from "../../config/constants";
import { filterCategoryInfoForDisplay } from "../helpers/formatters";

const getCategoryArray = (state) =>
	path([VERTICAL_INFORMATION, "categoryArray"], state);

/* Selectors from the Company Category model in Contentful */
export const categoryInfoSelector = createSelector(
	getCategoryArray,
	(categoryArray) => filterCategoryInfoForDisplay(categoryArray),
);

export const getCategoryName = createSelector(
	categoryInfoSelector,
	(categoryInfo) => path(["0", "fields", "categoryName"], categoryInfo),
);

export const getRatingTextParts = createSelector(
	categoryInfoSelector,
	(categoryInfo) => path(["0", "fields", "ratingTextParts"], categoryInfo),
);

export const getExpandServiceBenefitsText = createSelector(
	categoryInfoSelector,
	(categoryInfo) =>
		path(["0", "fields", "expandServiceBenefitsText"], categoryInfo),
);

export const getPhoneCallToActionText = createSelector(
	categoryInfoSelector,
	(categoryInfo) =>
		path(["0", "fields", "phoneCallToActionText"], categoryInfo),
);
